/*
  Reactivate Twente - Scroll reveal
  Voegt automatisch een fade-up animatie toe aan alle sections + child blocks
  via IntersectionObserver. Respecteert prefers-reduced-motion.
*/
(function () {
  if (window.__rtScrollInit) return;
  window.__rtScrollInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    document.documentElement.classList.add('rt-reveal-disabled');
    return;
  }

  // Selectors die we als reveal-target gebruiken
  var SELECTORS = [
    '.shopify-section > section',
    '.shopify-section > footer',
    '.shopify-section > .rt-section',
    // Kaarten/blokken binnen secties, zodat ze gefaseerd binnenkomen
    '.rt-route',
    '.rt-package',
    '.rt-testimonial',
    '.rt-principe',
    '.rt-traject__step',
    '.rt-blog-card',
    '.rt-opleidingen__row',
    '.rt-faq__item',
    '.rt-treatment',
    '.rt-search-card'
  ];

  function markReveal(el, index) {
    if (!el || el.dataset.rtReveal === '1') return;
    // Skip elementen die expliciet geen reveal willen, of waarvan een child sticky is.
    // Reveal-animatie zet transform op de section, en transform op een ancestor breekt position:sticky.
    if (el.hasAttribute('data-rt-no-reveal') || el.classList.contains('rt-pdp') || el.querySelector('[data-rt-pdp-media], .rt-pdp__media')) return;
    el.dataset.rtReveal = '1';
    el.classList.add('rt-reveal');
    if (typeof index === 'number') {
      el.style.setProperty('--rt-reveal-delay', (index * 60) + 'ms');
    }
  }

  function collect() {
    var nodes = [];
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { nodes.push(el); });
    });
    return nodes;
  }

  function setupObserver() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: alles direct zichtbaar
      document.querySelectorAll('.rt-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return null;
    }
    return new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  }

  function init() {
    var observer = setupObserver();
    var nodes = collect();

    // Stagger child-blokken per ouder
    var parents = new Map();
    nodes.forEach(function (el) {
      var parent = el.parentElement;
      var siblings = parents.get(parent) || 0;
      parents.set(parent, siblings + 1);
      markReveal(el, siblings);
      if (observer) observer.observe(el);
      else el.classList.add('is-visible');
    });

    // Bij design mode (theme editor) direct alles tonen
    if (window.Shopify && window.Shopify.designMode) {
      document.querySelectorAll('.rt-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init wanneer sections herladen worden in theme editor
  document.addEventListener('shopify:section:load', init);
})();
